import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { UserAddress } from '@features/address/interfaces/user-address.interface';
import { AddressService } from '@features/address/services/address.service';
import { faSpinner, faTimes } from '@fortawesome/free-solid-svg-icons';
import { SharedModule } from '@shared/shared.module';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Subject } from 'rxjs';

@Component({
  standalone: true,
  selector: 'fc-address-edit-dialog',
  templateUrl: './address-edit-dialog.component.html',
  styleUrls: ['./address-edit-dialog.component.css'],
  imports: [SharedModule],
})
export class AddressEditDialogComponent implements OnInit, OnDestroy {
  // font awesome icons
  faSpinner = faSpinner;
  faTimes = faTimes;

  // handler
  private readonly destroy$ = new Subject<void>();
  isSubmitted = false;
  loading = false;

  address: UserAddress;
  addressForm: FormGroup;

  constructor(
    private addressService: AddressService,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig
  ) {
    this.address = this.config.data.address;
    this.addressForm = new FormGroup({
      receiver_name: new FormControl('', Validators.required),
      postal_code: new FormControl('', Validators.required),
      phone_no: new FormControl('', Validators.required),
      address: new FormControl('', Validators.required),
      note: new FormControl(''),
    });
  }

  // lifecycle
  ngOnInit(): void {
    this.setupAddressForm(this.address);
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  setupAddressForm(address: UserAddress = {} as UserAddress) {
    this.addressForm.patchValue({
      receiver_name: address.receiver_name,
      postal_code: address.postal_code,
      phone_no: address.phone_no,
      address: address.address,
      note: address.note,
    });
  }
  onSubmit() {
    this.loading = true;
    if (this.addressForm?.valid) {
      this.addressService
        .editAddress(this.address.id, this.addressForm?.value)
        .subscribe({
          next: (res) => {
            this.loading = false;
            this.isSubmitted = false;
            this.ref.close(true);
          },
          error: (err) => {
            this.loading = false;
          },
        });
    } else {
      this.loading = false;
      this.isSubmitted = true;
    }
  }
  onClose(isUpdated: boolean = false) {
    this.ref.close(isUpdated);
  }
}
